
function bind_ajax_form_handler($, form)
{
    var $form = $(form);

    $form.submit(function(e) {

        if ($form.hasClass('ajax-form-handler-disabled')) {
            return;
        };

        e.preventDefault();

        var url = $form.attr('action');
        var method = $form.attr('method');

        $form.addClass('ajax-form-handler-handling');
        $form.append('<span class="ajax-loader loader-dual-ring"></span>');

        $.ajax({
            type: method,
            url: url,
            data: $form.serialize(),
            success: function(data)
            {
                var $container = $form.parent('.form-inner');
                var $response = $('<div></div>').html(data);
                var $inner = $response.find('.form-inner');

                $form.unbind('submit');
                $container.html($inner.html());

                $response.find('script').each(function(i) {
                    jQuery = $
                    eval($(this).html());
                });

                add_ajax_form_handler($);
            }
         });
    });
}

function add_ajax_form_handler($)
{
    $(".ajax-form-handler form").each(function() {
        bind_ajax_form_handler($, this);
    });
}

jQuery(document).ready(function($) {
    add_ajax_form_handler($);
});

